/* VIMZO CREATIONS – tumbler customizer
   3D engraving preview (model-viewer + engraver.js), flat render fallback,
   validation and add-to-cart with Shopify line-item properties:
   Tumbler Colour, Personalized Text, Language, Font, Orientation, Engraving Colour,
   Selected Icon, Selected Letter Graphic, Engraving Type, Original Uploaded Image,
   Engraving Preview Image, Engraving Layout. */
(function () {
  'use strict';

  var STORE_KEY = 'vimzo:customizer';
  var RETURN_KEY = 'vimzo:return-to-product';
  var root = document.querySelector('[data-customizer]');
  if (!root) return;
  var jsonEl = root.querySelector('[data-customizer-json]');
  if (!jsonEl) return;
  var cfg = JSON.parse(jsonEl.textContent);
  var V = window.VIMZO || {};
  var E = window.VimzoEngraver;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Helpers ---------- */
  function $(sel) { return root.querySelector(sel); }
  function $$(sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function slugify(str) {
    return String(str || '').toLowerCase().replace(/['"’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }
  function readStore() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY) || '{}') || {}; } catch (e) { return {}; }
  }
  function writeStore(obj) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(obj)); } catch (e) { /* ignore */ }
  }
  function checked(sel) { return root.querySelector(sel + ':checked'); }
  function clamp(n, min, max) { return Math.min(max, Math.max(min, n)); }
  var EMOJI_RE;
  try { EMOJI_RE = new RegExp('\\p{Extended_Pictographic}', 'u'); } catch (e) { EMOJI_RE = /[\uD83C-􏰀-\uDFFF]/; }

  /* ---------- Elements ---------- */
  var form = $('[data-customizer-form]');
  var idInput = $('[data-variant-input]');
  var textInput = $('[data-text-input]');
  var textError = $('[data-text-error]');
  var charCount = $('[data-char-count]');
  var qtyInput = $('[data-qty-input]');
  var img = $('[data-preview-img]');
  var zone = $('[data-preview-zone]');
  var design = $('[data-preview-design]');
  var previewText = $('[data-preview-text]');
  var previewIcon = $('[data-preview-icon]');
  var previewLetter = $('[data-preview-letter]');
  var artWrap = $('[data-art-wrap]');
  var previewArt = $('[data-preview-art]');
  var announcer = $('[data-preview-announce]');
  var colourLabel = $('[data-colour-label]');
  var fontLabel = $('[data-font-label]');
  var orientLabel = $('[data-orient-label]');
  var langLabel = $('[data-lang-label]');
  var langNote = $('[data-lang-note]');
  var diacriticsBox = $('[data-diacritics]');
  var vocalNote = $('[data-vocal-note]');
  var vocalText = $('[data-vocal-text]');
  var translitConfirm = $('[data-translit-confirm]');
  var translitFrom = $('[data-translit-from]');
  var translitLang = $('[data-translit-lang]');
  var backLink = $('[data-back-link]');
  var submitBtn = $('[data-customizer-submit]');
  var submitLabel = $('[data-submit-label]');
  var formError = $('[data-form-error]');
  var errorSummary = $('[data-error-summary]');
  // Engraving type (image upload)
  var engEmpty = $('[data-eng-empty]');
  var engDone = $('[data-eng-done]');
  var engCanvas = $('[data-eng-canvas]');
  var engScale = $('[data-eng-scale]');
  var engScaleLabel = $('[data-eng-scale-label]');
  var engBorder = $('[data-eng-border]');
  var engThumb = $('[data-eng-thumb]');
  var engName = $('[data-eng-name]');
  var uploadError = $('[data-upload-error]');
  var engModal = $('[data-eng-modal]');
  var engAgree = $('[data-eng-agree]');
  var engPick = $('[data-eng-pick]');
  var engFile = $('[data-eng-file]');
  var engError = $('[data-eng-error]');
  var viewer = $('[data-viewer]');
  var mv = $('[data-model-viewer]');
  var progressEl = $('[data-viewer-progress]');
  var sum = {};
  $$('[data-sum]').forEach(function (el) { sum[el.getAttribute('data-sum')] = el; });
  var artRow = $('[data-sum-row="artwork"]');

  var state = {
    variant: null,
    file: null, // original uploaded image (File)
    fileUrl: null,
    scale: 50, // uploaded design size, 0–100 (50 = default)
    rot: 0, // uploaded design rotation, degrees (0/90/180/270)
    pos: { x: 0, y: 0 }, // uploaded design offset from its default spot, % of the printable area
    border: false, // "Show engraving border" guide (never saved)
    layout: null, // actual placement after keeping the design inside the printable area
    angle: 0,
    touched: false,
    translit: null, // { source, result, approved } after an automatic English → Arabic/Urdu conversion
    skipAuto: null, // English text the customer chose to keep (Undo), so it isn't converted again
    vocal: null, // { before, after, keys } after automatic Arabic pronunciation marks
    vocalSkip: {}, // names the customer undid, so marks aren't added again
    aiSkip: {} // Arabic texts the customer undid the AI marks on
  };

  /* ---------- Current selections ---------- */
  function fontInfo() {
    var el = checked('[data-font-input]') || root.querySelector('[data-font-input]');
    return { key: el.getAttribute('data-key'), name: el.value, ratio: parseFloat(el.getAttribute('data-ratio')) || 0.3 };
  }
  function langInfo() {
    var el = checked('[data-lang-input]');
    var key = el ? el.getAttribute('data-key') : 'en';
    var L = (cfg.languages && cfg.languages[key]) || { name: 'English', dir: 'ltr', input: '', preview: cfg.placeholder };
    return { key: key, name: L.name, rtl: L.dir === 'rtl', input: L.input, preview: L.preview || cfg.placeholder, font: L.font };
  }
  state.langKey = langInfo().key; // language selected before the current click
  // Font actually used for the engraved text (Arabic/Urdu use their own script font)
  function engravingFontName() {
    var lang = langInfo();
    return lang.rtl && lang.font ? lang.font : fontInfo().name;
  }
  function orientInfo() {
    var el = checked('[data-orient-input]');
    return el ? { key: el.getAttribute('data-key'), name: el.value } : { key: 'horizontal', name: 'Horizontal' };
  }
  function iconInfo() {
    var el = checked('[data-icon-input]');
    if (!el || !el.getAttribute('data-key')) return null;
    var label = el.nextElementSibling;
    return {
      key: el.getAttribute('data-key'),
      name: el.value,
      type: el.getAttribute('data-type'),
      src: el.getAttribute('data-src'),
      label: label,
      svg: label ? label.querySelector('svg') : null
    };
  }
  function letterValue() {
    var el = checked('[data-letter-input]');
    return el ? el.value : '';
  }
  function displayText() { return textInput.value.replace(/\s+/g, ' ').trim(); }
  // Arabic pronunciation marks (Fatha, Damma, Kasra, Tanween, Shadda, Sukun, superscript Alif)
  var MARK_RE = /[ً-ْٰ]/g;
  // Length without marks, so Zabar/Zer/Pesh never count toward the character limit
  function baseLength(s) { return String(s || '').replace(MARK_RE, '').length; }

  /* ---------- Variant ---------- */
  function variantById(id) {
    return cfg.variants.find(function (v) { return String(v.id) === String(id); });
  }
  function variantBySlug(slug) {
    slug = slugify(slug);
    return cfg.variants.find(function (v) { return v.slug === slug && v.available; }) ||
      cfg.variants.find(function (v) { return v.slug === slug; });
  }

  function setVariant(v, opts) {
    if (!v) return;
    opts = opts || {};
    state.variant = v;
    idInput.value = v.id;
    var radio = root.querySelector('[data-colour-input][value="' + v.id + '"]');
    if (radio) radio.checked = true;
    if (colourLabel) colourLabel.textContent = v.colour;

    // Flat fallback images (renders)
    $$('[data-angle]').forEach(function (btn, i) {
      var t = btn.querySelector('img');
      if (t && v.renders && v.renders[i]) t.src = v.renders[i];
    });
    showAngle(state.angle, true);

    if (backLink) backLink.href = v.url;
    if (submitBtn) {
      submitBtn.disabled = !v.available;
      if (submitLabel) submitLabel.textContent = v.available ? cfg.buttonLabel : (V.strings ? V.strings.soldOut : 'Sold out');
    }
    if (opts.updateUrl !== false && history.replaceState) {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      url.searchParams.set('color', v.slug);
      history.replaceState({}, '', url.toString());
    }
    if (mv) mv.alt = 'Interactive 3D preview of your ' + v.colour + ' VIMZO tumbler';
    loadModel(v);
    render();
  }

  /* ---------- Flat fallback: angles ---------- */
  function showAngle(i, quiet) {
    state.angle = i;
    var v = state.variant;
    var src = v && v.renders && v.renders[i];
    if (img && src && img.getAttribute('src') !== src) {
      img.classList.add('is-swapping');
      var pre = new Image();
      pre.onload = pre.onerror = function () {
        img.src = src;
        img.classList.remove('is-swapping');
        fit();
      };
      pre.src = src;
    }
    if (zone) zone.hidden = i !== 0; // the engraving is on the front
    $$('[data-angle]').forEach(function (b) {
      var on = parseInt(b.getAttribute('data-angle'), 10) === i;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', String(on));
    });
    if (!quiet && i !== 0 && announcer) announcer.textContent = 'Showing another angle. Your engraving is on the front view.';
  }

  /* ---------- 3D viewer ---------- */
  var three = {
    ready: false,
    mat: null,
    bodyHex: '#cccccc',
    roughness: 0.62,
    token: 0,
    seq: 0,
    timer: null,
    baseRadius: 0,
    tex: null
  };
  var texSize = (function () {
    var big = window.matchMedia('(min-width: 990px)').matches && !/Mobi|Android/i.test(navigator.userAgent);
    return big ? { w: 1536, h: 3258 } : { w: 1024, h: 2172 };
  })();

  function setMode(mode) {
    if (!viewer) return;
    viewer.classList.toggle('is-loading', mode === 'loading');
    viewer.classList.toggle('is-3d', mode === '3d');
    viewer.classList.toggle('is-fallback', mode === 'fallback');
    if (mode !== '3d') three.ready = false;
    if (mode === 'fallback') showAngle(state.angle, true);
    requestAnimationFrame(fit);
  }

  function loadModel(v) {
    if (!mv || !v || !v.model || !E) { setMode('fallback'); return; }
    if (mv.getAttribute('src') === v.model && three.ready) { scheduleTexture(); return; }
    three.token++;
    three.ready = false;
    setMode('loading');
    if (progressEl) progressEl.textContent = '';
    if (mv.getAttribute('src') !== v.model) mv.setAttribute('src', v.model);
  }

  if (mv) {
    var mvDefined = window.customElements && customElements.get('model-viewer');
    // If the 3D library can't load (blocked/offline), fall back to the renders
    var mvTimeout = setTimeout(function () {
      if (!(window.customElements && customElements.get('model-viewer'))) setMode('fallback');
    }, 9000);
    if (!mvDefined && window.customElements) {
      customElements.whenDefined('model-viewer').then(function () { clearTimeout(mvTimeout); });
    }

    mv.addEventListener('progress', function (e) {
      var p = e.detail && e.detail.totalProgress;
      if (progressEl && typeof p === 'number') progressEl.textContent = Math.round(p * 100) + '%';
    });

    mv.addEventListener('load', function () {
      clearTimeout(mvTimeout);
      var mats = (mv.model && mv.model.materials) || [];
      var mat = mats.find(function (m) { return m.name === cfg.engrave.material; }) || null;
      if (!mat) { setMode('fallback'); return; }
      var pbr = mat.pbrMetallicRoughness;
      three.mat = mat;
      three.bodyHex = E.linearToHex(pbr.baseColorFactor);
      three.roughness = typeof pbr.roughnessFactor === 'number' ? pbr.roughnessFactor : 0.62;
      three.whiteSet = false;
      three.ready = true;
      var orbit = mv.getCameraOrbit();
      three.baseRadius = orbit.radius;
      mv.minCameraOrbit = 'auto 20deg ' + (orbit.radius * 0.42).toFixed(3) + 'm';
      mv.maxCameraOrbit = 'auto 110deg ' + (orbit.radius * 1.6).toFixed(3) + 'm';
      three.defaultRadius = orbit.radius;
      updateTexture(true);
    });

    mv.addEventListener('error', function () { setMode('fallback'); });

    // Hide the "drag to rotate" hint once the customer actually touches the model
    ['pointerdown', 'wheel'].forEach(function (ev) {
      mv.addEventListener(ev, function () { viewer.classList.add('has-interacted'); }, { passive: true });
    });
  }

  // Throttled (not debounced) so the 3D engraving keeps up while a design is being dragged
  function scheduleTexture() {
    if (!three.ready || three.timer) return;
    three.timer = setTimeout(function () { three.timer = null; updateTexture(false); }, 120);
  }

  // Builds the engraving for the current selections: { mask, engraved, layout }
  function buildEngraving() {
    var spec = engraveSpec();
    return Promise.all([
      E.ensureFonts(spec),
      E.iconMask(spec.iconInfo),
      E.artMask(spec.artUrl)
    ]).then(function (res) {
      spec.icon = res[1] ? { mask: res[1] } : null;
      spec.art = res[2];
      var mask = E.composeMask(spec);
      return { mask: mask, engraved: E.engrave(mask, cfg.engraveColour || '#A6A6A6'), layout: mask.layout };
    });
  }
  function bodyHex() {
    return three.ready ? three.bodyHex : ((state.variant && state.variant.hex) || '#CCCCCC');
  }

  function engraveSpec() {
    var text = displayText();
    var font = fontInfo();
    var icon = iconInfo();
    return {
      W: Math.round(cfg.engrave.widthCm * 64),
      H: Math.round(cfg.engrave.heightCm * 64),
      text: text || langInfo().preview,
      placeholder: !text,
      hideText: !text && !!state.fileUrl, // image-only engraving: no placeholder name
      artRot: state.rot,
      lang: langInfo().key,
      font: font.key,
      ratio: font.ratio,
      orient: orientInfo().key,
      iconInfo: icon,
      letter: letterValue(),
      letterStyle: design ? design.getAttribute('data-letter-style') : 'serif',
      letterFrame: design ? design.getAttribute('data-letter-frame') : 'circle',
      // Size slider 0–100 (100 = as large as fits the printable area)
      size: state.scale,
      pos: { x: state.pos.x, y: state.pos.y },
      artUrl: state.fileUrl
    };
  }

  function toBlobUrl(c, type, q) {
    return new Promise(function (resolve) {
      if (c.toBlob) c.toBlob(function (b) { resolve(b ? URL.createObjectURL(b) : c.toDataURL(type, q)); }, type, q);
      else resolve(c.toDataURL(type, q));
    });
  }

  function updateTexture(first) {
    if (!three.ready || !mv || !E) return;
    var seq = ++three.seq;
    var token = three.token;
    buildEngraving().then(function (r) {
      if (seq !== three.seq || token !== three.token) return null;
      var tex = E.buildTextures(r.engraved, r.mask, {
        texW: texSize.w,
        texH: texSize.h,
        bodyHex: three.bodyHex,
        roughness: three.roughness,
        map: cfg.engrave,
        border: state.border && !!state.fileUrl // placement guide only
      });
      return Promise.all([toBlobUrl(tex.base, 'image/jpeg', 0.92), toBlobUrl(tex.roughMetal, 'image/jpeg', 0.9)]);
    }).then(function (urls) {
      if (!urls) return null;
      if (seq !== three.seq || token !== three.token) { urls.forEach(revoke); return null; }
      return Promise.all([mv.createTexture(urls[0]), mv.createTexture(urls[1])]).then(function (t) {
        urls.forEach(revoke);
        if (seq !== three.seq || token !== three.token || !three.mat) return;
        var pbr = three.mat.pbrMetallicRoughness;
        pbr.baseColorTexture.setTexture(t[0]);
        pbr.metallicRoughnessTexture.setTexture(t[1]);
        if (!three.whiteSet) {
          pbr.setBaseColorFactor([1, 1, 1, 1]);
          pbr.setRoughnessFactor(1);
          pbr.setMetallicFactor(1);
          three.whiteSet = true;
        }
        // Any applied engraving finishes loading (a newer update can replace the first one)
        if (viewer && viewer.classList.contains('is-loading')) setMode('3d');
      });
    }).catch(function () {
      // Texture painting failed (e.g. very old browser): show the flat engraving preview instead
      if (viewer && viewer.classList.contains('is-loading')) setMode('fallback');
    });
  }
  function revoke(u) { if (u && u.indexOf('blob:') === 0) URL.revokeObjectURL(u); }

  // Viewer controls
  function zoomBy(f) {
    if (!mv || !three.ready) return;
    var o = mv.getCameraOrbit();
    var base = three.baseRadius || o.radius;
    var r = clamp(o.radius * f, base * 0.42, base * 1.6);
    mv.cameraOrbit = o.theta + 'rad ' + o.phi + 'rad ' + r + 'm';
  }
  function resetView() {
    if (!mv) return;
    mv.cameraOrbit = '0deg 82deg ' + (three.defaultRadius ? three.defaultRadius.toFixed(3) + 'm' : 'auto');
    mv.cameraTarget = 'auto auto auto';
    mv.fieldOfView = 'auto';
    viewer.classList.remove('has-interacted');
  }
  var fsBtn = $('[data-viewer-fullscreen]');
  var fsSupported = !!(document.fullscreenEnabled || document.webkitFullscreenEnabled);
  if (fsBtn && fsSupported) fsBtn.hidden = false;
  function toggleFullscreen() {
    var active = document.fullscreenElement || document.webkitFullscreenElement;
    if (active) {
      (document.exitFullscreen || document.webkitExitFullscreen).call(document);
    } else if (viewer) {
      var req = viewer.requestFullscreen || viewer.webkitRequestFullscreen;
      if (req) req.call(viewer);
    }
  }
  ['fullscreenchange', 'webkitfullscreenchange'].forEach(function (ev) {
    document.addEventListener(ev, function () {
      var on = !!(document.fullscreenElement || document.webkitFullscreenElement);
      viewer.classList.toggle('is-fullscreen', on);
      var lbl = $('[data-fullscreen-label]');
      if (lbl) lbl.textContent = on ? 'Exit full screen' : 'View full screen';
      requestAnimationFrame(fit);
    });
  });

  /* ---------- Flat preview layout (fallback) ---------- */
  function setVar(name, px) { design.style.setProperty(name, Math.max(0, px).toFixed(1) + 'px'); }

  function fit() {
    if (!zone || zone.hidden) return;
    var W = zone.clientWidth;
    var H = zone.clientHeight;
    if (!W || !H) return;
    var vertical = orientInfo().key === 'vertical';
    var hasArt = false; // uploaded designs use the exact engraving canvas instead (see renderEngravingViews)
    var hasLetter = !!letterValue();

    var script = E && E.SCRIPTS[langInfo().key];
    var fs = H * (script ? script.ratio : fontInfo().ratio) * (vertical ? 1.05 : 1);
    if (!vertical) { if (hasLetter) fs *= 0.62; if (hasArt) fs *= 0.6; }
    else if (hasArt || hasLetter) fs *= 0.8;
    var ls = vertical ? Math.min(W * 0.4, H * 0.3) : H * (hasArt ? 0.24 : 0.4);
    var artH = H * (vertical ? 0.42 : (hasLetter ? 0.38 : 0.46)) * (state.scale / 100);

    function apply() { setVar('--fs', fs); setVar('--ls', ls); setVar('--art-h', artH); }
    apply();

    var line = previewText.parentNode;
    var len = vertical ? line.offsetHeight : line.scrollWidth;
    var maxLen = (vertical ? H : W) * 0.96;
    if (len > maxLen) { fs *= maxLen / len; apply(); }

    function over() { return vertical ? design.offsetWidth / W : design.offsetHeight / H; }
    for (var i = 0; i < 6 && (over() > 1 || design.offsetHeight > H); i++) {
      var k = 1 / Math.max(over(), design.offsetHeight / H);
      if (hasArt && fs > H * 0.08) { fs *= Math.max(0.8, k); ls *= Math.max(0.8, k); }
      else { fs *= k; ls *= k; artH *= k; }
      apply();
    }
  }

  // "Position X: +4% · Position Y: −6% · Scale: 110% · Rotation: 90°"
  function layoutText() {
    var l = state.layout || { x: state.pos.x, y: state.pos.y, scale: state.scale, rotation: state.rot };
    function signed(n) { return (n > 0 ? '+' : n < 0 ? '−' : '') + Math.abs(n) + '%'; }
    return 'Position X: ' + signed(l.x) + ' · Position Y: ' + signed(l.y) + ' · Scale: ' + l.scale + '/100 · Rotation: ' + l.rotation + '°';
  }

  /* ---------- Engraving type: editor canvas + flat fallback ---------- */
  var flatEng = $('[data-flat-eng]');
  var engRendering = false;
  var engPending = false;
  // Draws the exact engraving (text + icon + letter + uploaded design) on the tumbler colour
  function renderEngravingViews() {
    if (!state.fileUrl || !E) {
      if (flatEng) flatEng.hidden = true;
      if (design) design.hidden = false;
      return;
    }
    if (engRendering) { engPending = true; return; }
    engRendering = true;
    buildEngraving().then(function (r) {
      state.layout = r.layout;
      // Keep the stored offset inside the printable area so dragging never feels stuck
      if (r.layout && !drag) { state.pos.x = r.layout.x; state.pos.y = r.layout.y; }
      if (engCanvas) E.renderFlat(engCanvas, r.engraved, bodyHex(), state.border);
      if (flatEng) {
        var fctx = flatEng.getContext('2d');
        flatEng.width = r.engraved.width;
        flatEng.height = r.engraved.height;
        fctx.clearRect(0, 0, flatEng.width, flatEng.height);
        fctx.drawImage(r.engraved, 0, 0);
        flatEng.hidden = false;
      }
      if (design) design.hidden = true;
      if (sum.artwork && state.file) sum.artwork.textContent = state.file.name + ' · size ' + state.scale + ' · ' + state.rot + '°';
    }).catch(function () {}).then(function () {
      engRendering = false;
      if (engPending) { engPending = false; renderEngravingViews(); }
    });
  }

  /* ---------- Render ---------- */
  var announceTimer;
  function render() {
    var v = state.variant;
    var font = fontInfo();
    var orient = orientInfo();
    var lang = langInfo();
    var icon = iconInfo();
    var letter = letterValue();
    var text = displayText();

    design.setAttribute('data-ff', font.key);
    design.setAttribute('data-orient', orient.key);
    design.setAttribute('data-lang', lang.key);
    if (fontLabel) fontLabel.textContent = font.name;
    if (orientLabel) orientLabel.textContent = orient.name;
    if (langLabel) langLabel.textContent = lang.name;

    // Text field: direction, language and placeholder follow the selected language
    textInput.setAttribute('dir', lang.rtl ? 'rtl' : 'ltr');
    textInput.setAttribute('lang', lang.key);
    if (lang.input) textInput.placeholder = lang.input;
    textInput.closest('.field').classList.toggle('field--rtl', lang.rtl);
    if (langNote) {
      var arabicScriptInEnglish = !lang.rtl && /[؀-ۿݐ-ݿ]/.test(text);
      langNote.hidden = !lang.rtl && !arabicScriptInEnglish;
      if (lang.rtl) langNote.textContent = lang.name + ' is engraved in ' + lang.font + ' with connected letters. Your font choice is used for any English letters.';
      else if (arabicScriptInEnglish) langNote.textContent = 'Your text looks like Arabic or Urdu. Choose Arabic or Urdu above for the best lettering.';
    }

    // Automatic conversion: ask the customer to check the spelling
    var tr = state.translit;
    if (translitConfirm) {
      translitConfirm.hidden = !(tr && !tr.approved);
      if (tr) {
        if (translitFrom) translitFrom.textContent = tr.source;
        if (translitLang) translitLang.textContent = lang.name;
      }
    }

    // Flat preview text
    var latinFamily = (E && E.FONTS[font.key] ? E.FONTS[font.key].family : 'Oswald');
    previewText.parentNode.setAttribute('dir', lang.rtl ? 'rtl' : 'ltr');
    previewText.setAttribute('lang', lang.key);
    if (lang.rtl && lang.font) {
      previewText.style.fontFamily = '"' + lang.font + '", "' + latinFamily + '"';
      previewText.style.fontWeight = '600';
      previewText.style.fontStyle = 'normal';
      previewText.style.letterSpacing = '0';
    } else {
      previewText.style.fontFamily = previewText.style.fontWeight = previewText.style.fontStyle = previewText.style.letterSpacing = '';
    }
    if (text) {
      previewText.textContent = text;
      previewText.classList.remove('is-placeholder');
    } else {
      previewText.textContent = lang.preview;
      previewText.classList.add('is-placeholder');
    }
    if (charCount) charCount.textContent = baseLength(textInput.value);
    textInput.maxLength = cfg.maxChars + (textInput.value.length - baseLength(textInput.value));
    if (diacriticsBox) diacriticsBox.hidden = lang.key !== 'ar';
    if (vocalNote) {
      vocalNote.hidden = !(state.vocal && lang.key === 'ar');
      if (state.vocal && vocalText) vocalText.textContent = state.vocal.after;
    }

    // Flat preview icon
    previewIcon.innerHTML = '';
    previewIcon.hidden = !icon;
    if (icon) {
      if (icon.type === 'image' && icon.src) {
        var m = document.createElement('span');
        m.className = 'preview__icon-mask';
        m.style.webkitMaskImage = m.style.maskImage = 'url("' + icon.src + '")';
        previewIcon.appendChild(m);
      } else if (icon.svg) {
        previewIcon.innerHTML = icon.svg.outerHTML;
      }
    }

    // Flat preview letter + artwork
    previewLetter.hidden = !letter;
    previewLetter.textContent = letter;
    if (artWrap) artWrap.hidden = true;

    // Engraving type section
    if (engEmpty) engEmpty.hidden = !!state.file;
    if (engDone) engDone.hidden = !state.file;
    if (engScale) engScale.value = state.scale;
    if (engScaleLabel) engScaleLabel.textContent = state.scale;
    if (engBorder) engBorder.checked = state.border;
    renderEngravingViews();

    // Chosen chips
    var iconChip = $('[data-chosen="icon"]');
    var letterChip = $('[data-chosen="letter"]');
    if (iconChip) { iconChip.hidden = !icon; if (icon) iconChip.querySelector('[data-chosen-label]').textContent = 'Icon: ' + icon.name; }
    if (letterChip) { letterChip.hidden = !letter; if (letter) letterChip.querySelector('[data-chosen-label]').textContent = 'Letter graphic: ' + letter; }

    // Summary
    var qty = Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1);
    if (sum.colour && v) sum.colour.textContent = v.colour;
    if (sum.text) sum.text.textContent = text || '—';
    if (sum.font) sum.font.textContent = engravingFontName();
    if (sum.lang) sum.lang.textContent = lang.name;
    if (sum.orient) sum.orient.textContent = orient.name;
    if (sum.icon) sum.icon.textContent = icon ? icon.name : 'No icon';
    if (sum.letter) sum.letter.textContent = letter || 'None';
    if (sum.qty) sum.qty.textContent = qty;
    if (sum.price && v) sum.price.textContent = V.formatMoney ? V.formatMoney(v.price * qty) : String(v.price * qty);
    if (artRow) artRow.hidden = !state.file;

    requestAnimationFrame(fit);
    scheduleTexture();

    clearTimeout(announceTimer);
    announceTimer = setTimeout(function () {
      if (!announcer) return;
      var bits = [text || 'no text yet', lang.name, engravingFontName(), orient.name.toLowerCase()];
      if (icon) bits.push(icon.name + ' icon');
      if (letter) bits.push('letter ' + letter);
      if (state.file) bits.push('your uploaded design');
      announcer.textContent = 'Engraving preview: ' + bits.join(', ') + ', on ' + (v ? v.colour : '') + '.';
    }, 700);

    save();
  }

  function save() {
    var icon = iconInfo();
    writeStore({
      productId: cfg.productId,
      variantId: state.variant && state.variant.id,
      text: textInput.value,
      font: fontInfo().key,
      lang: langInfo().key,
      orient: orientInfo().key,
      icon: icon ? icon.key : '',
      letter: letterValue(),
      qty: Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1)
    });
  }

  /* ---------- Automatic Arabic pronunciation marks for known names ---------- */
  var vocalTimer;
  function autoVocalize() {
    if (!window.VimzoVocalize || langInfo().key !== 'ar') return false;
    var v = textInput.value;
    if (/[A-Za-z]/.test(v)) return false; // English is converted first
    var out = window.VimzoVocalize(v, { skip: state.vocalSkip });
    if (out === v) return false;
    state.vocal = { before: v, after: out, keys: window.VimzoVocalizedKeys ? window.VimzoVocalizedKeys(v) : [] };
    keepTranslitResult(v, out);
    textInput.value = out;
    if (document.activeElement === textInput) {
      try { textInput.setSelectionRange(out.length, out.length); } catch (e) { /* ignore */ }
    }
    return true;
  }

  /* ---------- Automatic conversion between English, Arabic and Urdu ---------- */
  var ARABIC_SCRIPT = /[؀-ۿ]/;
  // Which language the text in the field is written in ('en', 'ar' or 'ur')
  function textLang(text, fallback) {
    if (!ARABIC_SCRIPT.test(text)) return 'en';
    return window.VimzoDetectScript ? window.VimzoDetectScript(text, fallback) : (fallback === 'ur' ? 'ur' : 'ar');
  }
  // opts.force: the customer just picked the language, so always convert the text
  // opts.from: the language that was selected before
  function autoConvert(langKey, opts) {
    opts = opts || {};
    if (!window.VimzoConvert) return;
    var current = textInput.value;
    var tr = state.translit;
    if (opts.force) state.skipAuto = null;
    var base = null;
    if (tr && current === tr.result) {
      // Switching again re-converts from what the customer originally wrote
      base = { text: tr.source, lang: tr.srcLang };
    } else if (tr && tr.srcLang === 'en' && current.indexOf(tr.result) === 0 && /[A-Za-z]/.test(current.slice(tr.result.length))) {
      // More English typed after an earlier conversion, e.g. "Ali" → علي, then " Khan"
      base = { text: tr.source + current.slice(tr.result.length), lang: 'en' };
    } else if (current.trim()) {
      var latin = /[A-Za-z]/.test(current);
      var script = ARABIC_SCRIPT.test(current);
      if (latin && !script) { if (opts.force || !keptEnglish(current)) base = { text: current, lang: 'en' }; }
      else if (script && !latin && opts.force) base = { text: current, lang: textLang(current, opts.from) };
    }
    if (!base) {
      if (!(tr && current === tr.result)) state.translit = null;
      return;
    }
    if (base.lang === langKey) {
      // Back to the language it was written in: restore it exactly
      if (current !== base.text) textInput.value = base.text;
      state.translit = null;
      return;
    }
    var result = window.VimzoConvert(base.text, base.lang, langKey);
    if (langKey === 'ar' && window.VimzoVocalize) result = window.VimzoVocalize(result, { skip: state.vocalSkip });
    textInput.value = result;
    state.translit = { source: base.text, srcLang: base.lang, result: result, approved: false };
    state.vocal = null;
    if (document.activeElement === textInput && textInput.setSelectionRange) {
      try { textInput.setSelectionRange(result.length, result.length); } catch (e) { /* ignore */ }
    }
    aiUpgradeTranslit(base.text, base.lang, langKey);
  }
  // Marks added after a conversion still count as the converted text
  function keepTranslitResult(before, after) {
    if (state.translit && state.translit.result === before) state.translit.result = after;
  }

  /* ---------- Optional AI name conversion (Theme settings → AI name conversion) ----------
     The built-in list converts instantly; when a Worker URL is set, its answer replaces
     the instant result a moment later, as long as the customer hasn't changed the text. */
  var aiCache = {};
  function askAI(text, from, to) {
    if (!cfg.aiUrl || !window.fetch) return Promise.resolve(null);
    var key = from + '>' + to + '|' + text;
    if (aiCache[key]) return aiCache[key];
    var ctrl = window.AbortController ? new AbortController() : null;
    var timer = ctrl ? setTimeout(function () { ctrl.abort(); }, 10000) : null;
    var p = fetch(cfg.aiUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text: text, from: from, lang: to }),
      signal: ctrl ? ctrl.signal : undefined
    })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var out = d && typeof d.result === 'string' ? d.result.replace(/\s+/g, ' ').trim() : '';
        if (!out) return null;
        // English must come back in English letters, Arabic and Urdu in their own script
        if (to === 'en' ? ARABIC_SCRIPT.test(out) : /[A-Za-z]/.test(out)) return null;
        return out;
      })
      .catch(function () { return null; })
      .then(function (out) {
        clearTimeout(timer);
        if (!out) delete aiCache[key]; // try again next time
        return out;
      });
    aiCache[key] = p;
    return p;
  }
  function aiUpgradeTranslit(source, from, to) {
    askAI(source, from, to).then(function (out) {
      var tr = state.translit;
      if (!out || !tr || tr.approved || tr.source !== source || langInfo().key !== to) return;
      if (textInput.value !== tr.result || out === tr.result) return;
      textInput.value = out;
      tr.result = out;
      state.vocal = null;
      render();
    });
  }
  // Arabic typed directly: add Zabar, Zer and Pesh without changing the customer's letters
  function aiVocalize() {
    if (!cfg.aiUrl || !window.VimzoApplyMarks || langInfo().key !== 'ar') return;
    var shown = textInput.value;
    var typed = state.vocal ? state.vocal.before : shown;
    if (!typed.trim() || /[A-Za-z]/.test(typed) || typed.replace(MARK_RE, '') !== typed || state.aiSkip[typed]) return;
    askAI(typed, 'ar', 'ar').then(function (out) {
      if (!out || langInfo().key !== 'ar' || textInput.value !== shown) return;
      var marked = window.VimzoApplyMarks(typed, out);
      if (marked === typed || marked === shown) return;
      state.vocal = { before: typed, after: marked, keys: (state.vocal && state.vocal.keys) || [] };
      keepTranslitResult(shown, marked);
      textInput.value = marked;
      render();
    });
  }  var liveTimer;
  // After Undo the customer keeps their English text (and anything they add to it) until they pick a language again
  function keptEnglish(v) { return !!state.skipAuto && String(v).indexOf(state.skipAuto) === 0; }

  /* ---------- Panels (Choose an Icon / Add a Letter Graphic) ---------- */
  function togglePanel(name, force) {
    var panel = $('[data-panel="' + name + '"]');
    var btn = $('[data-panel-toggle="' + name + '"]');
    if (!panel) return;
    var open = typeof force === 'boolean' ? force : panel.hidden;
    panel.hidden = !open;
    if (btn) btn.setAttribute('aria-expanded', String(open));
    if (open) {
      var focusEl = panel.querySelector('.option-input:checked') || panel.querySelector('button, input');
      if (focusEl && force !== true) focusEl.focus({ preventScroll: true });
      panel.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest' });
    }
  }

  function filterIcons(cat) {
    $$('[data-cat-tab]').forEach(function (b) {
      var on = b.getAttribute('data-cat-tab') === cat;
      b.classList.toggle('is-active', on);
      b.setAttribute('aria-pressed', String(on));
    });
    var visible = 0;
    $$('[data-icon-grid] .icon-grid__item').forEach(function (item) {
      var c = item.getAttribute('data-cat');
      var show = c === 'any' || cat === 'all' || c === cat;
      item.hidden = !show;
      if (show && c !== 'any') visible++;
    });
    var empty = $('[data-cat-empty]');
    if (empty) {
      empty.hidden = visible > 0;
      $('[data-cat-empty-letters]').hidden = cat !== 'letters';
      $('[data-cat-empty-default]').hidden = cat === 'letters';
    }
  }

  /* ---------- Validation ---------- */
  function validateText(show) {
    var raw = textInput.value.trim();
    var msg = '';
    // Text is optional when an image is uploaded for engraving
    if (!raw && !state.file) msg = 'Please add a name or short message, or upload an image to engrave.';
    else if (baseLength(raw) > cfg.maxChars) msg = 'Please keep your text to ' + cfg.maxChars + ' characters or fewer.';
    else if (EMOJI_RE.test(raw)) msg = 'Emoji can’t be engraved. Please use letters, numbers and simple punctuation, or choose an icon below.';
    if (show) {
      textError.textContent = msg;
      textError.hidden = !msg;
      if (msg) textInput.setAttribute('aria-invalid', 'true'); else textInput.removeAttribute('aria-invalid');
    }
    return msg;
  }

  var ENG_TYPES = /^image\/(png|jpe?g|webp|svg\+xml)$/i;
  function validateFile(file) {
    if (!file) return '';
    var okType = ENG_TYPES.test(file.type) || /\.(png|jpe?g|webp|svg)$/i.test(file.name);
    if (!okType) return 'Please upload a PNG, JPG, JPEG, WEBP or SVG file.';
    if (file.size > cfg.maxUploadMb * 1024 * 1024) return 'Your file is larger than ' + cfg.maxUploadMb + ' MB. Please upload a smaller file.';
    return '';
  }
  function showSummary(errors) {
    if (!errorSummary) return;
    var list = errorSummary.querySelector('ul');
    list.innerHTML = '';
    errors.forEach(function (e) {
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + e.target.id;
      a.textContent = e.message;
      a.addEventListener('click', function (ev) { ev.preventDefault(); e.target.focus(); });
      li.appendChild(a);
      list.appendChild(li);
    });
    errorSummary.hidden = errors.length === 0;
  }

  /* ---------- Engraving type: upload guidelines modal ---------- */
  var modalReturnFocus = null;
  function openEngModal() {
    if (!engModal) return;
    modalReturnFocus = document.activeElement;
    if (engError) { engError.textContent = ''; engError.hidden = true; }
    if (engPick && engAgree) engPick.disabled = !engAgree.checked;
    engModal.hidden = false;
    document.documentElement.classList.add('is-locked');
    requestAnimationFrame(function () {
      engModal.classList.add('is-open');
      var panel = engModal.querySelector('.eng-modal__panel');
      if (panel) panel.focus({ preventScroll: true });
    });
  }
  function closeEngModal() {
    if (!engModal || engModal.hidden) return;
    engModal.classList.remove('is-open');
    engModal.hidden = true;
    document.documentElement.classList.remove('is-locked');
    if (modalReturnFocus && modalReturnFocus.focus) modalReturnFocus.focus({ preventScroll: true });
  }
  if (engModal) {
    engModal.addEventListener('click', function (e) {
      if (e.target.closest('[data-eng-close]')) closeEngModal();
    });
    engModal.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); closeEngModal(); return; }
      if (e.key !== 'Tab') return;
      var items = Array.prototype.filter.call(
        engModal.querySelectorAll('button:not([disabled]), input:not([type="file"]), a[href]'),
        function (el) { return el.offsetParent !== null; }
      );
      if (!items.length) return;
      var first = items[0], last = items[items.length - 1];
      if (e.shiftKey && (document.activeElement === first || document.activeElement.classList.contains('eng-modal__panel'))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }
  if (engAgree && engPick) {
    engAgree.addEventListener('change', function () { engPick.disabled = !engAgree.checked; });
    engPick.addEventListener('click', function () { if (!engPick.disabled && engFile) engFile.click(); });
  }
  if (engFile) {
    engFile.addEventListener('change', function () {
      var file = engFile.files && engFile.files[0];
      engFile.value = '';
      if (!file) return;
      var msg = validateFile(file);
      if (msg) { engError.textContent = msg; engError.hidden = false; return; }
      // Make sure the browser can read it before accepting
      var url = URL.createObjectURL(file);
      var probe = new Image();
      probe.onload = function () { setUploadedFile(file, url); closeEngModal(); };
      probe.onerror = function () {
        URL.revokeObjectURL(url);
        engError.textContent = 'Sorry, that image could not be read. Please try another file.';
        engError.hidden = false;
      };
      probe.src = url;
    });
  }

  function setUploadedFile(file, url) {
    if (state.fileUrl) URL.revokeObjectURL(state.fileUrl);
    state.file = file || null;
    state.fileUrl = file ? url : null;
    state.scale = 50;
    state.rot = 0;
    state.pos = { x: 0, y: 0 };
    state.layout = null;
    if (uploadError) uploadError.hidden = true;
    if (engName) engName.textContent = file ? file.name : '';
    if (engThumb) { if (file) engThumb.src = url; else engThumb.removeAttribute('src'); }
    render();
    if (file && engCanvas) {
      requestAnimationFrame(function () { engCanvas.focus({ preventScroll: true }); });
      engCanvas.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
    }
  }

  /* ---------- Engraving type: placement controls ---------- */
  function resetPlacement() {
    state.scale = 50;
    state.rot = 0;
    state.pos = { x: 0, y: 0 };
    render();
  }
  if (engScale) {
    engScale.addEventListener('input', function () {
      var v = parseInt(engScale.value, 10);
      state.scale = clamp(isNaN(v) ? 50 : v, 0, 100);
      render();
    });
  }
  if (engBorder) {
    engBorder.addEventListener('change', function () {
      state.border = engBorder.checked;
      render();
    });
  }

  // Drag (mouse + touch) and keyboard on the placement canvas
  var drag = null;
  if (engCanvas) {
    engCanvas.addEventListener('pointerdown', function (e) {
      if (!state.fileUrl) return;
      e.preventDefault();
      try { engCanvas.setPointerCapture(e.pointerId); } catch (err) { /* keep dragging without capture */ }
      drag = { x: e.clientX, y: e.clientY };
      engCanvas.classList.add('is-dragging');
    });
    engCanvas.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var r = engCanvas.getBoundingClientRect();
      if (!r.width || !r.height) return;
      state.pos.x = clamp(state.pos.x + ((e.clientX - drag.x) / r.width) * 100, -60, 60);
      state.pos.y = clamp(state.pos.y + ((e.clientY - drag.y) / r.height) * 100, -60, 60);
      drag = { x: e.clientX, y: e.clientY };
      renderEngravingViews();
      scheduleTexture();
    });
    var endDrag = function () {
      if (!drag) return;
      drag = null;
      engCanvas.classList.remove('is-dragging');
      render();
    };
    engCanvas.addEventListener('pointerup', endDrag);
    engCanvas.addEventListener('pointercancel', endDrag);
    engCanvas.addEventListener('keydown', function (e) {
      if (!state.fileUrl) return;
      var step = e.shiftKey ? 10 : 2;
      var k = e.key;
      if (k === 'ArrowLeft') state.pos.x -= step;
      else if (k === 'ArrowRight') state.pos.x += step;
      else if (k === 'ArrowUp') state.pos.y -= step;
      else if (k === 'ArrowDown') state.pos.y += step;
      else if (k === 'r' || k === 'R') { e.preventDefault(); resetPlacement(); return; }
      else return;
      e.preventDefault();
      state.pos.x = clamp(state.pos.x, -60, 60);
      state.pos.y = clamp(state.pos.y, -60, 60);
      render();
    });
  }

  // Engraving preview image for the order (no placement border)
  function engravingPreviewFile() {
    return buildEngraving().then(function (r) {
      var c = E.renderFlat(document.createElement('canvas'), r.engraved, bodyHex(), false);
      state.layout = r.layout;
      return new Promise(function (resolve) {
        c.toBlob(function (b) { resolve(b ? new File([b], 'engraving-preview.png', { type: 'image/png' }) : null); }, 'image/png');
      });
    }).catch(function () { return null; });
  }

  /* ---------- Events ---------- */
  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches('[data-colour-input]')) { setVariant(variantById(t.value)); return; }
    if (t.matches('[data-lang-input]')) {
      clearTimeout(liveTimer);
      clearTimeout(vocalTimer);
      state.vocal = null;
      var toKey = t.getAttribute('data-key');
      autoConvert(toKey, { force: true, from: state.langKey });
      state.langKey = toKey;
      autoVocalize();
      aiVocalize();
      render();
      return;
    }
    if (t.matches('[data-font-input], [data-orient-input], [data-icon-input], [data-letter-input], [data-qty-input]')) render();
  });

  root.addEventListener('click', function (e) {
    var t = e.target;
    var toggle = t.closest('[data-panel-toggle]');
    if (toggle) { togglePanel(toggle.getAttribute('data-panel-toggle')); return; }
    var tab = t.closest('[data-cat-tab]');
    if (tab) { filterIcons(tab.getAttribute('data-cat-tab')); return; }
    if (t.closest('[data-open-letters]')) { togglePanel('letter', true); return; }
    var clear = t.closest('[data-clear]');
    if (clear) {
      var which = clear.getAttribute('data-clear');
      var none = root.querySelector(which === 'icon' ? '[data-icon-input][data-key=""]' : '[data-letter-input][value=""]');
      if (none) none.checked = true;
      render();
      return;
    }
    // Engraving type
    if (t.closest('[data-eng-open]')) { openEngModal(); return; }
    if (t.closest('[data-eng-remove]')) {
      setUploadedFile(null, null);
      var openBtn = root.querySelector('[data-eng-empty] [data-eng-open]');
      if (openBtn) openBtn.focus();
      return;
    }
    if (t.closest('[data-eng-rotate]')) { state.rot = (state.rot + 90) % 360; render(); return; }
    if (t.closest('[data-eng-reset]')) { resetPlacement(); return; }
    var angle = t.closest('[data-angle]');
    if (angle) { showAngle(parseInt(angle.getAttribute('data-angle'), 10)); return; }
    var zoomBtn = t.closest('[data-viewer-zoom]');
    if (zoomBtn) { zoomBy(zoomBtn.getAttribute('data-viewer-zoom') === 'in' ? 0.82 : 1.22); return; }
    if (t.closest('[data-viewer-reset]')) { resetView(); return; }
    if (t.closest('[data-viewer-fullscreen]')) { toggleFullscreen(); return; }

    if (t.closest('[data-vocal-undo]')) {
      if (state.vocal) {
        textInput.value = state.vocal.before;
        (state.vocal.keys || []).forEach(function (k) { state.vocalSkip[k] = true; });
        state.aiSkip[state.vocal.before] = true;
      }
      state.vocal = null;
      render();
      textInput.focus();
      return;
    }
    // Automatic conversion: approve or undo
    if (t.closest('[data-translit-keep]')) {
      if (state.translit) state.translit.approved = true;
      render();
      return;
    }
    if (t.closest('[data-translit-undo]')) {
      if (state.translit) {
        textInput.value = state.translit.source;
        state.skipAuto = state.translit.source;
      }
      state.translit = null;
      render();
      textInput.focus();
    }
  });

  textInput.addEventListener('input', function () {
    var lang = langInfo();
    clearTimeout(liveTimer);
    if (lang.rtl && /[A-Za-z]/.test(textInput.value) && !keptEnglish(textInput.value)) {
      // English typed while Arabic/Urdu is selected: convert as soon as the customer pauses
      liveTimer = setTimeout(function () { autoConvert(lang.key); render(); }, 600);
    } else {
      // Editing the Arabic/Urdu text itself counts as reviewing it
      state.translit = null;
      state.vocal = null;
      clearTimeout(vocalTimer);
      if (lang.key === 'ar') {
        vocalTimer = setTimeout(function () { if (autoVocalize()) render(); aiVocalize(); }, 700);
      }
    }
    render();
    if (state.touched || EMOJI_RE.test(textInput.value)) validateText(true);
  });
  textInput.addEventListener('blur', function () {
    // English typed while Arabic/Urdu is selected converts automatically when the customer leaves the field
    var lang = langInfo();
    if (lang.rtl && /[A-Za-z]/.test(textInput.value) && !keptEnglish(textInput.value)) {
      clearTimeout(liveTimer);
      autoConvert(lang.key);
      render();
    }
    if (textInput.value.trim()) { state.touched = true; validateText(true); }
  });
  if (backLink) {
    backLink.addEventListener('click', function () {
      try { sessionStorage.setItem(RETURN_KEY, String(cfg.productId)); } catch (e) { /* ignore */ }
    });
  }
  window.addEventListener('resize', function () { requestAnimationFrame(fit); });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    state.touched = true;
    var errors = [];
    var textMsg = validateText(true);
    if (textMsg) errors.push({ target: textInput, message: textMsg });
    var fileMsg = validateFile(state.file);
    if (fileMsg && engCanvas) errors.push({ target: engCanvas, message: fileMsg });
    if (!state.variant || !state.variant.available) {
      errors.push({ target: root.querySelector('[data-colour-input]'), message: 'This colour is sold out. Please choose another colour.' });
    }
    if (state.translit && !state.translit.approved) {
      errors.push({ target: root.querySelector('[data-translit-keep]'), message: 'Please check the ' + langInfo().name + ' spelling we converted, then tap “Looks right” or edit it.' });
    }
    showSummary(errors);
    if (errors.length) {
      errors[0].target.focus();
      errors[0].target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    var icon = iconInfo();
    var letter = letterValue();
    var text = displayText();

    if (!V.addToCart) { form.submit(); return; }

    submitBtn.disabled = true;
    submitBtn.classList.add('is-loading');
    submitLabel.textContent = state.file ? 'Uploading your design…' : (V.strings ? V.strings.adding : 'Adding…');
    if (formError) formError.hidden = true;

    (state.file ? engravingPreviewFile() : Promise.resolve(null)).then(function (previewFile) {
      var fd = new FormData();
      fd.append('id', state.variant.id);
      fd.append('quantity', Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1));
      fd.append('properties[Tumbler Colour]', state.variant.colour);
      if (text) fd.append('properties[Personalized Text]', text);
      fd.append('properties[Language]', langInfo().name);
      fd.append('properties[Font]', engravingFontName());
      fd.append('properties[Orientation]', orientInfo().name);
      fd.append('properties[Engraving Colour]', 'Grey #A6A6A6');
      if (icon) fd.append('properties[Selected Icon]', icon.name);
      if (letter) fd.append('properties[Selected Letter Graphic]', letter);
      if (state.file) {
        fd.append('properties[Engraving Type]', 'Custom Image Upload');
        fd.append('properties[Original Uploaded Image]', state.file, state.file.name);
        fd.append('properties[_Uploaded image name]', state.file.name);
        if (previewFile) fd.append('properties[Engraving Preview Image]', previewFile, previewFile.name);
        fd.append('properties[Engraving Layout]', layoutText());
      }
      return V.addToCart(fd);
    })
      .then(function () {
        submitLabel.textContent = 'Added to cart';
        submitBtn.classList.add('is-success');
        if (V.openCart) V.openCart();
        setTimeout(function () {
          submitLabel.textContent = cfg.buttonLabel;
          submitBtn.classList.remove('is-success');
        }, 2200);
      })
      .catch(function (err) {
        if (formError) { formError.textContent = err.message; formError.hidden = false; }
        submitLabel.textContent = cfg.buttonLabel;
      })
      .finally(function () {
        submitBtn.disabled = false;
        submitBtn.classList.remove('is-loading');
      });
  });

  /* ---------- Init: URL → saved state → defaults ---------- */
  var params = new URLSearchParams(window.location.search);
  var saved = readStore();
  var hasSaved = String(saved.productId) === String(cfg.productId);

  if (hasSaved) {
    if (typeof saved.text === 'string') textInput.value = saved.text;
    var f = saved.font && root.querySelector('[data-font-input][data-key="' + saved.font + '"]');
    if (f) f.checked = true;
    var lg = saved.lang && root.querySelector('[data-lang-input][data-key="' + saved.lang + '"]');
    if (lg) { lg.checked = true; state.langKey = saved.lang; }
    var o = saved.orient && root.querySelector('[data-orient-input][data-key="' + saved.orient + '"]');
    if (o) o.checked = true;
    var ic = saved.icon && root.querySelector('[data-icon-input][data-key="' + saved.icon + '"]');
    if (ic) ic.checked = true;
    var lt = saved.letter && root.querySelector('[data-letter-input][value="' + saved.letter + '"]');
    if (lt) lt.checked = true;
    if (saved.qty && qtyInput) qtyInput.value = saved.qty;
  }

  var startVariant =
    variantById(params.get('variant')) ||
    (params.get('color') && variantBySlug(params.get('color'))) ||
    (hasSaved && variantById(saved.variantId)) ||
    variantById(idInput.value) ||
    cfg.variants[0];

  filterIcons('all');

  // Show the selected font card in the horizontal font row on mobile
  var selFont = checked('[data-font-input]');
  if (selFont && selFont.nextElementSibling) {
    var fontRow = selFont.closest('.font-grid');
    if (fontRow && fontRow.scrollWidth > fontRow.clientWidth) fontRow.scrollLeft = Math.max(0, selFont.nextElementSibling.offsetLeft - 16);
  }

  setVariant(startVariant, { updateUrl: params.has('variant') || params.has('color') });

  if (document.fonts) {
    if (document.fonts.ready) document.fonts.ready.then(function () { fit(); scheduleTexture(); });
    if (document.fonts.addEventListener) document.fonts.addEventListener('loadingdone', function () { fit(); scheduleTexture(); });
  }
})();
